import classNames from 'classnames'
import { motion } from 'framer-motion'
import React, { forwardRef } from 'react'

import styles from './View.module.scss'

export interface ViewProps {
  children?: React.ReactNode
  className?: string
  fadeIn?: boolean
  fadeOut?: boolean
  onClick?: () => void
}

const transition = { ease: 'easeInOut', duration: 0.35 }

const fadeInVariants = {
  initial: {
    opacity: 0,
    transition,
  },
  enter: {
    opacity: 1,
    transition,
  },
}

const fadeOutVariants = {
  initial: {
    opacity: 1,
  },
  leave: {
    opacity: 0,
    transition,
  },
}

export const View = forwardRef<HTMLDivElement, ViewProps>(
  ({ children, className, fadeIn, fadeOut, onClick }, ref) => {
    let motionProps: any = fadeIn
      ? {
          initial: 'initial',
          animate: 'enter',
          variants: fadeInVariants,
        }
      : {}

    motionProps = fadeOut
      ? {
          initial: 'initial',
          animate: 'exit',
          variants: fadeOutVariants,
        }
      : motionProps

    return (
      <motion.div
        {...motionProps}
        className={classNames(styles.view, className)}
        onClick={onClick}
        ref={ref}
      >
        {children}
      </motion.div>
    )
  }
)

View.displayName = 'View'
